import React, { Fragment, useEffect, useState } from "react";
import { Tabs, TabPanel } from "react-tabs";
import { Button, Form, FormGroup, Label } from "reactstrap";
import "../../assets/styles/admin.css";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import Loader from "../loader/loader";
import Select from "react-select";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

const AddCountryForm = ({ payload, setPayload }) => {
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const history = useHistory();

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let countryId = query.get("id");

  // Enable Toggle
  const handleSwitchChange = () => {
    setPayload({
      ...payload,
      isEnabled: !payload?.isEnabled,
    });
  };

  // Block Whole Country Toggle
  const handleBlockWholeCountry = () => {
    setPayload({
      ...payload,
      blockWholeCountry: !payload?.blockWholeCountry,
      state: null,
    });
  };

  // Country Change (Single Select)
  const handleCountryChange = (selectedOption) => {
    setPayload({
      ...payload,
      country: selectedOption,
      state: null,
    });

    if (selectedOption) {
      handleFetchStates(selectedOption.value);
    } else {
      setState([]);
    }
  };

  // State Change
  const handleStateChange = (selectedOption) => {
    setPayload({
      ...payload,
      state: selectedOption,
    });
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    let response;

    if (!payload?.country) {
      return toast.error("Please select country");
    }

    if (!payload?.blockWholeCountry && !payload?.state) {
      return toast.error("Please select state or block whole country");
    }

    try {
      setLoading(true);

      const finalPayload = {
        isEnabled: payload?.isEnabled,
        blockWholeCountry: payload?.blockWholeCountry || false,
        restrictedCountry: {
          name: payload?.country?.value,
          code: payload?.country?.code,
        },
        restrictedState: payload?.blockWholeCountry
          ? null
          : payload?.state?.map((s) => s.value) || [],
      };
      if (countryId) {
        response = await adminInstance().put(
          `api/admin/updateRegionRest/${countryId}`,
          finalPayload,
        );
      } else {
        response = await adminInstance().post(
          `api/admin/createRegionRest`,
          finalPayload,
        );
      }

      if (response.data.code === 200) {
        toast.success(response.data.message);
        history.push("/region-restriction");
      } else {
        toast.error(response.data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Server Error");
    } finally {
      setLoading(false);
    }
  };

  // Fetch Countries
  const handlefetchCountries = async () => {
    try {
      const response = await axios.get(
        "https://countriesnow.space/api/v0.1/countries",
      );

      if (response.status === 200) {
        const countryData = response.data.data?.map((elem) => ({
          label: elem.country,
          value: elem.country,
          code: elem.iso2,
        }));

        setCountry(countryData);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  useEffect(() => {
    handlefetchCountries();
  }, []);

  // Fetch States
  const handleFetchStates = async (countryName) => {
    try {
      const response = await axios.post(
        "https://countriesnow.space/api/v0.1/countries/states",
        { country: countryName },
      );

      if (response.status === 200) {
        const stateData = response.data.data.states?.map((elem) => ({
          label: elem.name,
          value: elem.name,
        }));

        setState(stateData);
      }
    } catch (error) {
      console.log("Error fetching states:", error);
    }
  };

  useEffect(() => {
    if (payload?.country) {
      handleFetchStates(payload.country.value);
    }
  }, [payload?.country]);

  const getSingleCountryData = async (id) => {
    try {
      setLoading(true);
      const response = await adminInstance().get(
        `api/admin/getSingleRegionRest/${id}`,
      );
      const { code, data } = response.data;
      if (code === 200) {
        setPayload({
          ...payload,
          isEnabled: data?.isEnabled,
          blockWholeCountry: data?.blockWholeCountry,
          country: {
            label: data?.restrictedCountry?.name,
            value: data?.restrictedCountry?.name,
            code: data?.restrictedCountry?.code,
          },
          state:
            data?.restrictedState?.map((s) => ({
              label: s,
              value: s,
            })) || [],
        });
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (countryId) {
      getSingleCountryData(countryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryId]);

  return (
    <Fragment>
      {loading && <Loader />}

      <Tabs>
        <TabPanel>
          <Form
            className="needs-validation user-add admin-type"
            onSubmit={handleSubmit}>
            {/* Enable Switch */}
            <FormGroup>
              <Label className="col-form-label pt-0 d-block">
                Enable Region Restriction
              </Label>

              <div className="custom-toggle">
                <input
                  type="checkbox"
                  id="regionSwitch"
                  checked={payload?.isEnabled || false}
                  onChange={handleSwitchChange}
                />
                <label htmlFor="regionSwitch"></label>
              </div>
            </FormGroup>

            {/* Country Select */}
            <FormGroup className="row justify-content-start mx-0">
              <div className="admin-input col-xl-6 col-md-8">
                <Label className="col-form-label pt-0">
                  <span>*</span> Country
                </Label>

                <Select
                  value={payload?.country || null}
                  options={country}
                  onChange={handleCountryChange}
                  isDisabled={!payload?.isEnabled}
                  placeholder="Select Country..."
                />
              </div>
            </FormGroup>

            {/* Block Whole Country */}
            <FormGroup className="row justify-content-start mx-0">
              <div className="form-group form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={payload?.blockWholeCountry || false}
                  onChange={handleBlockWholeCountry}
                  disabled={!payload?.isEnabled}
                />
                <Label className="col-form-label pt-0 d-block">
                  Block Hole Country
                </Label>
              </div>
            </FormGroup>

            {/* State Select */}
            {!payload?.blockWholeCountry && (
              <FormGroup className="row justify-content-start mx-0">
                <div className="admin-input col-xl-6 col-md-8">
                  <Label className="col-form-label pt-0">
                    <span>*</span> State
                  </Label>

                  <Select
                    isMulti
                    value={payload?.state || []}
                    options={state}
                    onChange={handleStateChange}
                    isDisabled={!payload?.isEnabled}
                    placeholder="Select State..."
                  />
                </div>
              </FormGroup>
            )}

            {/* Submit */}
            <div className="form-button d-flex justify-content-start pt-3">
              <Button
                disabled={loading}
                color="primary"
                type="submit"
                className="main-btn">
                {countryId
                  ? loading
                    ? "Updating..."
                    : "Update"
                  : loading
                    ? "Saving..."
                    : "Submit"}
              </Button>
            </div>
          </Form>
        </TabPanel>
      </Tabs>
    </Fragment>
  );
};

export default AddCountryForm;
